import React, { useEffect, useState } from "react";

import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import { db, firebaseAuth } from "../db/firestore";
import { useParams } from "react-router-dom";
import { Modal_FlatlistImage, Modal_Loading } from "../modal";
import { LargeHorizontalNoPro, LargeHorizontalWithPro, LargeVerticalNoPro, LargeVerticalWithPro, MiniNoPro, MiniWithPro } from "../components";
import bwipjs from 'bwip-js';
import { colors } from "../configs";
import { formatTime } from "../Utility/function";
import { Button } from "react-bootstrap";
import { stringFullDate } from "../Utility/dateTime";

const { white } = colors;

const anynonymous  = [
    "owner@gmail.com", "owner2@gmail.com", "owner3@gmail.com", 
    "owner4@gmail.com", "owner5@gmail.com", "owner6@gmail.com", 
    "owner7@gmail.com", "owner8@gmail.com", "owner9@gmail.com", 
    "owner10@gmail.com", 
  ];


const priceTagSizes = [
    { id:1,name:'ป้ายใหญ่แนวตั้งมีโปรโมชั่น', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2FPromotion%20Large%20Portraid.webp?alt=media&token=9aec44fb-e3fa-42c4-9ed9-8d0d35904e55' },
    { id:2,name:'ป้ายใหญ่แนวตั้ง', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2Fno%20Promotion%20Large%20Portraid%20(1).webp?alt=media&token=9b88054d-96da-44e6-ac23-ef75c7f9dbe5' },
    { id:3,name:'ป้ายใหญ่แนวนอนมีโปรโมชั่น', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2FPromotion%20Large%20Landscape.webp?alt=media&token=a0b015d7-b1cf-492d-ac07-e6e28bd0469d' },
    { id:4,name:'ป้ายใหญ่แนวนอน', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2Fno%20Promotion%20Large%20Landscape.webp?alt=media&token=8be2d89e-de12-4b77-a5c6-a285a8f222fc' },
    { id:5,name:'ป้ายเล็กมีโปรโมชั่น', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2FPromotion%20Small%20webp.webp?alt=media&token=4a9f58e0-29d5-4574-b7d6-89b15c7e3fa6' },
    { id:6,name:'ป้ายเล็ก', imageId:'https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/webP%2Fno%20Promotion%20small.webp?alt=media&token=d61ef8d9-6738-4e1c-9d97-2c5a182474f4' },
];


function PriceCardScreen() {
    const { docId } = useParams();
    const [loading, setLoading] = useState(false);
    const [tag_Modal, setTag_Modal] = useState(false);
    const [priceTag, setPriceTag] = useState({ id:1,name:'ป้ายใหญ่แนวตั้งมีโปรโมชั่น' });
    const { name } = priceTag;

    const [products, setProducts] = useState([]);

    useEffect(()=>{
        handleFetch()
    },[]);

    async function handleFetch(){
        setLoading(true)
        try {
            await firebaseAuth.signInWithEmailAndPassword(anynonymous[Math.floor(Math.random() * anynonymous.length)], '123456');
            const priceTagData = await db.collection('priceTag').doc(docId).get();
            if(priceTagData.exists){
                const { products } = priceTagData.data();
                const newProducts = products.map(item=>{
                    const { promotion, barcode } = item;
                    return {
                        ...item,
                        barcodeImage:barcode?imageBase64(barcode):'',
                        promotion:{
                            ...promotion,
                            startDate:formatTime(promotion.startDate),
                            endDate:formatTime(promotion.endDate)
                        }
                    }
                })
                setProducts(newProducts)
            }
        } catch (error) {
            alert(error)
            setLoading(false)
        } finally {
            setLoading(false)
        }

    };


    function imageBase64(barcode){
        const canvas = document.createElement('canvas');
        bwipjs.toCanvas(canvas, {
            bcid: 'code128', // Barcode type
            text: barcode, // Barcode number
            scale: 3,
            height: 4,
            includetext: false, // We will add the text manually above the barcode
            textxalign: 'center',
        });
        return canvas.toDataURL('image/png')
    };

    function handleSize(item){
        setPriceTag(item);
        setTag_Modal(false)
    };

    const priceTagComponents = {
        1: <LargeVerticalWithPro data={products} />,
        2: <LargeVerticalNoPro data={products} />,
        3: <LargeHorizontalWithPro data={products} />,
        4: <LargeHorizontalNoPro data={products} />,
        5: <MiniWithPro data={products} />
    };

    const selectedComponent = priceTagComponents[priceTag.id] || <MiniNoPro data={products} />;

        const isThaiConsonant = (char) => {
  const code = char.charCodeAt(0);
  return (code >= 0x0E01 && code <= 0x0E2E); // พยัญชนะไทย ก-ฮ
};

const cutThaiTextByConsonants = (text, maxConsonants) => {
  let result = '';
  let count = 0;
  for (let char of text) {
    if (isThaiConsonant(char)) {
      count++;
    }
    result += char;
    if (count >= maxConsonants) break;
  }
  return result;
};


  return (
    <div style={{  height: '100vh', display: 'flex', flexDirection: 'column', justifyContent:'center', backgroundColor:white, width:'100vw' }}>
        <Modal_Loading show={loading} />
        <Modal_FlatlistImage
            header="เลือกป้ายราคาที่ต้องการ"
            show={tag_Modal}
            onHide={()=>{setTag_Modal(false)}}
            value={priceTagSizes}
            onClick={handleSize}
        />
      <h1>ทำป้ายราคา</h1>
      {products.length>0
            ?<React.Fragment>
                <div style={{ textAlign: 'center', marginTop: 10 }}>
                    <PDFDownloadLink document={selectedComponent} fileName={`${name}${stringFullDate(new Date())}.pdf`}>
                    {({ blob, url, loading, error }) =>
                        loading ? <Button style={{width:'170px',padding:20 ,borderRadius:20 }} variant="secondary" >กำลังประมาณผล</Button> : <Button style={{width:'170px',padding:20, borderRadius:20}} variant="success" >ดาวน์โหลด</Button>

                    }
                    </PDFDownloadLink>&emsp;
                    <Button onClick={()=>{setTag_Modal(true)}} variant="warning" style={{width:'170px',padding:20 ,borderRadius:20, color:white }} >เปลี่ยนขนาดป้าย</Button>
                </div>
                <PDFViewer style={{ width:'95%', height:'100%' }}>
                    {selectedComponent}
                </PDFViewer>
            </React.Fragment>
            :null
        }
        <br/>
        
    </div>
  );
};

const styles = {

}

export default PriceCardScreen;